export const normalizeNonBreakingSpaces = (value: string): string =>
  value.replace(/&nbsp;/g, ' ').replace(/\u00a0/g, ' ');
